module.exports = __webpack_public_path__ + "static/media/bangladesh.347fee81.png";